/** @format */

// vendor
import { SetupContext } from "@vue/composition-api";
// local
import { translateKey } from "@/services/Translate";

export const useTranslate = (context: SetupContext) => {
	const translate = (key: string): string => {
		const lang: string =
			context.root.$store.getters["localization/preferredLanguage"];
		return translateKey(key, lang);
	};

	return {
		translate,
	};
};
